import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCTS } from "../data/products";

const CartContext = createContext(null);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem("raystance_bag")) || [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("raystance_bag", JSON.stringify(items));
  }, [items]);

  const add = (id) =>
    setItems((prev) => {
      const found = prev.find((i) => i.id === id);
      if (found) return prev.map((i) => (i.id === id ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
      return [...prev, { id, qty: 1 }];
    });

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  const setQty = (id, qty) =>
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))
    );

  const clear = () => setItems([]);

  const value = useMemo(() => {
    const detailed = items
      .map((i) => ({ ...i, product: PRODUCTS.find((p) => p.id === i.id) }))
      .filter((i) => i.product);
    const count = detailed.reduce((s, i) => s + i.qty, 0);
    const subtotal = detailed.reduce((s, i) => s + i.qty * i.product.price, 0);
    return { items: detailed, count, subtotal, add, remove, setQty, clear, isOpen, setIsOpen };
  }, [items, isOpen]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
